import React, { useEffect, useState, useCallback } from "react";
import MainLayoutWithoutFooter from "../components/MainLayoutWithoutFooter";
import { useNavigate, useLocation } from "react-router-dom";
import { callAPI } from "../utils/apiUtils";
import { apiUrls } from "../utils/apiUrls";
import {
  getOrderStatusLabel,
  getOrderTypeLabel,
  getOrderPaidLabel,
  getServerName,
  getOrderSourceLabel
} from "../helper/OrderStatus";
import OrderDetails from "../components/modals/Orderdetails";
import { HTTP_STATUS } from "../utils/httpStatusCodes";
import { toast } from "react-toastify";
import debounce from "lodash.debounce";
import DriverUpdateModal from "../components/modals/DriverUpdateModal";
import RefundModal from "../components/modals/RefundModal";
import LinklyRefundStatusModal from "../components/modals/LinklyRefundStatusModal";
import {
  isOfflineAndroid,
  getOfflineOrders,
} from "..//utils/androidOfflineCart";


const isParentOrder = (order) =>
  order.childOrders && order.childOrders.length > 0;

const showCheckbox = (order) => order.paymode == 1;

const canEditOrder = (order) =>
  !isParentOrder(order) && order.orderstatus < 5;

const canShowStatusChange = (order) =>
  !isParentOrder(order) && order.orderstatus < 7;

const hasDriver = (order) => !!order.driver_id;

const getStatusOptions = (order) => [
  { value: "", label: "Change Status", disabled: true },
  {
    value: "cooking",
    label: "Cooking",
    disabled: order.orderstatus >= 5,
  },
  {
    value: "ready",
    label: "Ready",
    disabled: order.orderstatus >= 6,
  },
  // {
  //   value: "delivery",
  //   label: "Out",
  //   disabled: order.orderstatus < 5 || order.orderstatus >= 7,
  // },
  {
    value: "delivery",
    label: "Out",
    disabled:
      order.orderstatus < 5 ||
      order.orderstatus >= 7 ||
      (order.ordertype == 2 && !hasDriver(order)),
  },
  {
    value: "completed",
    label: "Completed",
    disabled: order.orderstatus === 7,
  },
];

const Orders = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // useEffect(() => {
  //   if (!localStorage.getItem("accessToken")) navigate("/");
  // }, [navigate]);

  
  const [filter, setFilter] = useState("today");
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [meta, setMeta] = useState({ currentPage: 1, pageCount: 1, perPage: 20 });
//  const [expandedRow, setExpandedRow] = useState(null);
const [expandedRowId, setExpandedRowId] = useState(null);

  const [orderId, setOrderId] = useState(null);
  const [search, setSearch] = useState(() => {
    // Pre-fill from the payment-link bell icon's "?order_search=" link, if present.
    const params = new URLSearchParams(window.location.search);
    return params.get('order_search') || '';
  });
  // The term actually sent to the API — only updates once `search` clears or
  // reaches the 3-character minimum, so we don't hit the server on every keystroke.
  const [appliedSearch, setAppliedSearch] = useState(search);

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [confirmTraining, setConfirmTraining] = useState(false);
  
  const [showDriverModal, setShowDriverModal] = useState(false);
  const [driverOrderId, setDriverOrderId] = useState(null);

  const [showRefundModal, setShowRefundModal] = useState(false);
  const [refundOrder, setRefundOrder] = useState(null);
  const [showRefundStatusModal, setShowRefundStatusModal] = useState(false);
  const [refundSessionId, setRefundSessionId] = useState(null);

  const [activeTab, setActiveTab] = useState(() => {
    // Pre-select the tab from the payment-link bell icon's "?type=" link, if present.
    const params = new URLSearchParams(window.location.search);
    return params.get('type') || "all";
  });
  const matchesTab = (order) => {
    const type = order.ordertype;
    const source = order.source;

    switch (activeTab) {
      case "dinein":
        return type == 3;

      case "delivery":
        return type == 2;

      case "pos_takeaway":
        return type == 1 && source === "pos";

      case "pos_delivery":
        return type == 2 && source === "pos";

      case "website_takeaway":
        return type == 1 && (source === "website" || source === "ai");

      case "website_delivery":
        return type == 2 && (source === "website" || source === "ai");

      case "uber":
        return source === "uber";

      case "table_order":
        return source === "table_order";

      default:
        return true;
    }
  };

  // Re-syncs the tab/search from the URL when the payment-link bell icon navigates here
  // while this page is already mounted — react-router doesn't remount on a same-route
  // navigate(), so the useState() lazy initializers above only fire once and would
  // otherwise miss a second bell click without a full page reload in between.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlType = params.get('type');
    const urlSearch = params.get('order_search');
    if (urlType) {
      setActiveTab(urlType);
    }
    if (urlSearch !== null) {
      setSearch(urlSearch);
      setAppliedSearch(urlSearch);
    }
  }, [location.search]);

  // Clears the leftover order-search filter and query params left behind by the
  // payment-link bell icon's deep link once staff manually switches to another tab —
  // otherwise the search box keeps silently scoping every tab to that one order.
  const handleTabClick = (tabKey) => {
    setActiveTab(tabKey);
    setSearch('');
    setAppliedSearch('');
    const url = new URL(window.location.href);
    url.searchParams.delete('order_search');
    url.searchParams.set('type', tabKey);
    window.history.replaceState({}, '', url);
  };

  const fetchOrders = useCallback(
    async (page = 1) => {
      setLoading(true);
      try {

          // OFFLINE ANDROID: fetch orders from Room SQLite.
      if (isOfflineAndroid()) {
        const result = await getOfflineOrders();
        console.log(
  "[OFFLINE_ORDERS] Raw result:",
  JSON.stringify(result, null, 2)
);

        // Support either a direct array or a wrapped response.
        const localOrders = Array.isArray(result)
          ? result
          : Array.isArray(result?.orders)
          ? result.orders
          : [];

        console.log(
          "[OFFLINE_ORDERS] Retrieved orders:",
          localOrders.length
        );

        console.log(
  "[OFFLINE_ORDERS] First raw order:",
  JSON.stringify(localOrders[0], null, 2)
);
       const mappedOrders = localOrders.map((order) => {
  const localOrderId =
    order.localOrderId ??
    order.id ??
    "";

  const normalizedOrderType = String(
    order.orderType ?? ""
  ).toLowerCase();

  const ordertype =
    normalizedOrderType === "dinein"
      ? 3
      : normalizedOrderType === "takeaway"
      ? 1
      : null;

  return {
    ...order,

    // Local order identifiers
    id: String(localOrderId),
    localOrderId: String(localOrderId),

    orderid:
      order.orderid ??
      order.orderNumber ??
      order.backendOrderId ??
      localOrderId,

    // Convert Room orderType to the React UI format
    ordertype,

    // All locally created orders originate from the POS
    source: "pos",

    // Customer information
    customer_name:
      order.customer_name ??
      order.customerName ??
      "",

    // Preserve server and table identifiers
    server_id:
      order.server_id ??
      order.serverId ??
      null,

    table_id:
      order.table_id ??
      order.tableId ??
      null,

    // Order status
    orderstatus: Number(
      order.orderstatus ??
      order.status ??
      0
    ),

    // Payment status
    paid: Number(
      order.paid ??
      order.isPaid ??
      0
    ),

    // Amounts
    FinalAmount: Number(
      order.FinalAmount ??
      order.finalAmount ??
      order.total ??
      0
    ),

    total: Number(order.total ?? 0),

    subtotal: Number(order.subtotal ?? 0),

    tax: Number(order.tax ?? 0),

    discount: Number(order.discount ?? 0),

    // Creation date
    created_at:
      order.created_at ??
      order.createdAt ??
      null,

    // Items saved with the order
    items: Array.isArray(order.items)
      ? order.items
      : [],

    childOrders: order.childOrders ?? [],
  };
});

        // Keep all locally saved orders, including paid orders.
        setOrders(mappedOrders);

        setMeta({
          currentPage: 1,
          pageCount: 1,
          perPage: mappedOrders.length || 20,
        });

        return;
      }


        //const url = `${apiUrls.ORDER_LISTS_URL}?filter=${filter}&page=${page}&length=${meta.perPage}`;
        let url = `${apiUrls.ORDER_LISTS_URL}?filter=${filter}&type=${activeTab}&page=${page}&length=${meta.perPage}`;
        if (appliedSearch) {
          url += `&search=${encodeURIComponent(appliedSearch)}`;
        }
        const res = await callAPI(url, "GET");

        setOrders(res.data.items.data || []);
        setMeta({
          currentPage: res.data._meta?.currentPage || 1,
          pageCount: res.data._meta?.pageCount || 1,
          perPage: res.data._meta?.perPage || 20,
        });
      } catch {
        setOrders([]);
      } finally {
        setLoading(false);
      }
    },
    [filter, meta.perPage, activeTab, appliedSearch]
  );

  useEffect(() => {
    fetchOrders(meta.currentPage);
  }, [filter, meta.currentPage, fetchOrders]);

  // Only search once the user has typed at least 3 characters (or cleared the
  // box entirely) so we don't fire an API call for every 1-2 character keystroke.
  const debouncedApplySearch = useCallback(
    debounce((value) => {
      setMeta((prev) => ({ ...prev, currentPage: 1 }));
      setAppliedSearch(value);
    }, 400),
    []
  );

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);

    const trimmed = value.trim();
    if (trimmed.length === 0 || trimmed.length >= 3) {
      debouncedApplySearch(trimmed);
    }
  };

  

  const handleEditOrder = (order) => {
    
    const orderType =
      order.ordertype == 1 || order.ordertype == 2
        ? "takeaway"
        : order.ordertype == 3 || order.ordertype == 4
        ? "dinein"
        : null; 
    navigate("/order-review", {
      state: {
        checkout_type: "finalise-order",
        // This order hasn't been sent yet, so showing its own pending items via edit_order_id is
        // correct here (OrderReview.js fetches it order-scoped, no session merge). existing_order_id
        // is included too so that if the user then clicks Add More Items, OrderDetails.js has
        // something to carry forward - see its comment on why it sends existing_order_id and not
        // edit_order_id.
        edit_order_id: order.id,
        existing_order_id: order.id,
        orderType,
        order_server_id: order.server_id
      },
   });
  };

  // const handleCollapseRow = (index, orderId) => {
  //   setExpandedRow(expandedRow === index ? null : index);
  //   setOrderId(orderId)
  // };

  const handleCollapseRow = (orderId) => {
    setExpandedRowId((prev) => (prev === orderId ? null : orderId));
  };
  

  const handleOrderDetails = (id) => () => setOrderId(id);

  
  const toggleSelectOrder = (orderId) => {
    setSelectedOrders((prev) =>
      prev.includes(orderId)
        ? prev.filter((id) => id !== orderId)
        : [...prev, orderId]
    );
  };

  
  const handleMarkTraining = () => {
    if (!selectedOrders.length) {
      toast.error("No Order Selected!");
      return;
    }
    setConfirmTraining(true);
  };

  const confirmMarkTrainingOrders = async () => {
    await callAPI(apiUrls.DELETE_ORDERS, {}, "POST", {
      orders: JSON.stringify(selectedOrders),
    });
    toast.success("Orders are marked deleted.");
    setSelectedOrders([]);
    setConfirmTraining(false);
    fetchOrders(meta.currentPage);
  };

  
  const updateOrderStatus = async (id, status) => {
    if (!status) return;

    const res = await callAPI(apiUrls.UPDATE_ORDER_STATUS, {}, "POST", {
      id,
      status,
    });

    if (res.data.status == 1) {
      toast.success(res.data.message);
      fetchOrders(meta.currentPage);
    } else {
      toast.error(res.data.message);
    }
  };

  const handlePrint = (orderId, isParent, docket) => async () => {
    let url = `${apiUrls.ORDER_PRINT_URL}?order_id=${orderId}&docket=${docket}`;
  
    if (isParent) {
      url += "&multiple_orders=true";
    }
  
    try {
      const res = await callAPI(url, "GET");
  
      if (res?.data?.status === 1 || res.status === HTTP_STATUS.OK) {
        toast.success(res.data?.message || "Print sent");
      } else {
        toast.error(res.data?.message || "Print failed");
      }
    } catch (e) {
      toast.error("Print failed");
    }
  };
  
  const formatShortDate = (date) => {
    if (!date) return "--";
    const d = new Date(date);
    return d.toLocaleDateString("en-GB") + " " +
           d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
  };
  
  const canCheckout = (order) =>
    !isParentOrder(order) &&
    (order.paid == 0 || order.paid == null) &&
    (order.ordertype == 1 || order.ordertype == 2);

    const handleCheckout = (orderId) => {
      // resuming_unpaid_order=1 tells the backend this order's kitchen docket already went out
      // when it was first checked out unpaid — canCheckout() only shows this action for orders
      // that are already unpaid, so every call through here is a resume, never a first finalize.
      navigate(`/payment-view?order_id=${orderId}&resuming_unpaid_order=1`);
      // i think it should have table id
    };

    // Search is now performed server-side (see fetchOrders' `search` query param);
    // only the tab type still needs filtering on the client.
    const finalOrders = orders.filter(matchesTab);

    const handlePageChange = (page) => {
      if (page < 1 || page > meta.pageCount) return;
    
      setMeta((prev) => ({
        ...prev,
        currentPage: page,
      }));

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

    };

    const getPaginationPages = () => {
      const pages = [];
      const total = meta.pageCount;
      const current = meta.currentPage;
    
      if (total <= 7) {
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        pages.push(1);
    
        if (current > 3) pages.push("...");
    
        for (
          let i = Math.max(2, current - 1);
          i <= Math.min(total - 1, current + 1);
          i++
        ) {
          pages.push(i);
        }
    
        if (current < total - 2) pages.push("...");
    
        pages.push(total);
      }
    
      return pages;
    };

  return (
    <MainLayoutWithoutFooter>
      <div className="pageContent orderPage pb-3">
        <div className="container">

          
          <div className="sbRow gap-2 mb-3">
            <h2 className="lgTitle mb-0">Orders</h2>
            <div className="ms-auto d-flex gap-2">
              <button
                className="btn iconBtn btnPrimary"
                onClick={() => navigate("/pending-orders")}
              >
                <span>Pending Orders</span>
              </button>
              <button
                className="btn iconBtn btnPrimary"
                onClick={handleMarkTraining}
              >
                <span>Mark Orders As Training</span>
              </button>
            </div>
          </div>

          <div className="pb-3">
  <div className="btn-group " >
    {[
      { key: "all", label: "All" },
      { key: "dinein", label: "Dine-in" },
      { key: "pos_takeaway", label: "POS Takeaway" },
      { key: "pos_delivery", label: "POS Delivery" },
      { key: "website_takeaway", label: "Website Takeaway" },
      { key: "website_delivery", label: "Website Delivery" },
      { key: "uber", label: "Uber" },
      { key: "table_order", label: "NFC Table Orders" },
    ].map((tab) => (
      <button
        key={tab.key}
        className={`btn ${
          activeTab === tab.key ? "btnPrimary" : "btn-outline-secondary"
        }`}
        onClick={() => handleTabClick(tab.key)}
      >
        {tab.label}
      </button>
    ))}
  </div>
</div>
          <div className="customerCol">
  <div className="row gx-2 gy-3 gy-lg-0 align-items-center mb-4">

    <div className="col-md">
      <form
        className="formStyle searchStyle tabSearchInput mbFullWd"
        onSubmit={(e) => e.preventDefault()}
      >
        <svg width="17" height="18" className="searchIcon">
          <use xlinkHref="./images/sprite.svg#iconSearch"></use>
        </svg>

        <input
          type="text"
          className="form-control"
          placeholder="Search by Order ID, Name, Phone"
          value={search}
          onChange={handleSearchChange}
        />
      </form>
    </div>

    <div className="col-md-auto">
      <div className="btnGroup justify-content-end tableFilterBtns">
        {[
          ["today", "Today"],
          ["yesterday", "Yesterday"],
          ["seven_days", "Last 7 days"],
          ["thirty_days", "Last 30 days"],
        ].map(([value, label], i) => (
          <React.Fragment key={value}>
            <input
              type="radio"
              className="btn-check"
              name="tFilterRadio"
              id={`filter-${i}`}
              autoComplete="off"
              value={value}
              checked={filter === value}
              onChange={(e) => {
                setFilter(e.target.value);
                setMeta((p) => ({ ...p, currentPage: 1 }));
              }}
            />

            <label className="radioBtn" htmlFor={`filter-${i}`}>
              {label}
            </label>
          </React.Fragment>
        ))}
      </div>
    </div>

  </div>
</div>

          
          <div className="cardStyle">
            <div className="table-responsive">
              <table className="table tableStyle2 table-borderless align-middle">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Order ID</th>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Type</th>
                    <th>Server</th>
                    <th>Paid</th>
                    <th>Date Time</th>
                    <th>Change Status</th>
                    <th width="70">Actions</th>
                  </tr>
                </thead>

                <tbody>
                {finalOrders.map((order, index) => {
                    const isParent = isParentOrder(order);

                    return (
                      <React.Fragment key={order.id}>
                        <tr>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                          {showCheckbox(order) && (
                              <input
                                type="checkbox"
                                className="form-check-input m-0"
                                checked={selectedOrders.includes(order.id)}
                                onChange={() => toggleSelectOrder(order.id)}
                              />
                            )}
                            {isParent && (
                              <button
                                className="btn btn-sm btn-outline-secondary px-2 py-0"
                                onClick={() => handleCollapseRow(order.id)}
                              >
                                {expandedRowId === order.id ? "-" : "+"}
                              </button>
                            )}


                          </div>
                        </td>


                          <td>{order.orderid}</td>
                          <td>
                          {order.customer_name ||
                            `${order.orderUser?.firstName || ""} ${order.orderUser?.lastName || ""}`}

                          {order.orderUser?.contactNumber && (
                              <div className="text-muted small">
                                ({order.orderUser.contactNumber})
                              </div>
                            )}
                          {order.tender && (
                            <div className="text-muted small">
                              {order.tender}
                            </div>
                          )}
                          </td>
                          <td>{getOrderStatusLabel(order.orderstatus)}</td>
                          <td>
                            {getOrderTypeLabel(order)}
                            <div className="text-muted small">
                              {getOrderSourceLabel(order)}
                            </div>

                          </td>
                          <td>
                            {getServerName(order)}
                            {order.driver_name && (
                              <div className="text-muted small">
                                Driver: {order.driver_name}
                              </div>
                            )}
                          </td>
                          <td>{getOrderPaidLabel(order)}</td>
                          <td>
                            {formatShortDate(order.created_at)}
                            {order.payment_date && (
                              <div className="text-muted small">
                                Paid: {formatShortDate(order.payment_date)}
                              </div>
                            )}
                          </td>
                          <td>
                            {!isParent && order.orderstatus < 7 ? (
                              // <select
                              //   className="form-select form-select-sm"
                              //   defaultValue=""
                              //   onChange={(e) =>
                              //     updateOrderStatus(order.id, e.target.value)
                              //   }
                              // >
                              //   <option value="">Change Status</option>
                              //   <option value="cooking" disabled={order.orderstatus >= 5}>
                              //     Cooking
                              //   </option>
                              //   <option value="ready" disabled={order.orderstatus >= 6}>
                              //     Ready
                              //   </option>
                              //   <option value="delivery" disabled={order.orderstatus < 5}>
                              //     Out
                              //   </option>
                              //   <option value="completed" disabled={order.orderstatus == 7}>
                              //     Completed
                              //   </option>
                              // </select>
                              <select className="form-select form-select-sm" defaultValue=""
                                      onChange={(e) => updateOrderStatus(order.id, e.target.value)}>
                                {getStatusOptions(order).map((opt) => (
                                  <option key={opt.value} value={opt.value} disabled={opt.disabled}>
                                    {opt.label}
                                  </option> 
                                ))}
                              </select>
                            ) : (
                              "--"
                            )}
                          </td>


                          
                          <td>
                          <div className="d-flex align-items-center gap-2">
                                          
                          {canCheckout(order) && (
                              <a
                                href="#"
                                className="d-block"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleCheckout(order.id);
                                }}
                                title="Checkout"
                              >
                                <svg width="20" height="20" className="ddItemIcon d-block" style={{ color: "yellow" }}>
                                  <use xlinkHref="./images/sprite.svg#iconCheckout"></use>
                                </svg>
                              </a>
                            )}

                            <div className="dotDropdownOptions btn-group">
                              <div
                                className="dotOptionTrigger"
                                data-bs-toggle="dropdown"
                              >
                                ⋮
                              </div>

                              <ul className="dropdown-menu ddMenuStyle dropdown-menu-end">

                                {canEditOrder(order) && (
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleEditOrder(order)
                                      }
                                    >
                                      Edit
                                    </button>
                                  </li>
                                )}

                                {!isParent && (
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={handleOrderDetails(order.id)}
                                      data-bs-toggle="modal"
                                      data-bs-target="#orderDetailModal"
                                    >
                                      Details
                                    </button>
                                  </li>
                                )}

                                {order.ordertype == 2 && !isParent && (
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={() => {
                                        setDriverOrderId(order.id);
                                        setShowDriverModal(true);
                                      }}
                                    >
                                      Update Driver
                                    </button>
                                  </li>
                                )}

                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={handlePrint(
                                      order.id,
                                      isParent,
                                      "billing"
                                    )}
                                  >
                                    Billing
                                  </button>
                                </li>

                                {!isParent && (
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={handlePrint(
                                        order.id,
                                        false,
                                        "kitchen"
                                      )}
                                    >
                                      Kitchen
                                    </button>
                                  </li>
                                )}

                                
                                {order.paid == 1 && order.paymode == 2 && !isParent && (
                                  <li>
                                    {order.total_refund_amount > 0 ? (
                                      <button className="dropdown-item text-muted" disabled>
                                        Refunded
                                      </button>
                                    ) : (
                                      <button
                                        className="dropdown-item text-danger"
                                        onClick={() => {
                                          setRefundOrder({ id: order.id, amount: order.FinalAmount });
                                          setShowRefundModal(true);
                                        }}
                                      >
                                        Refund
                                      </button>
                                    )}
                                  </li>
                                )}

                                {canShowStatusChange(order) && (
                                  <li className="px-3">
                                    <select
                                      className="form-control"
                                      defaultValue=""
                                      onChange={(e) =>
                                        updateOrderStatus(
                                          order.id,
                                          e.target.value
                                        )
                                      }
                                    >
                                      {getStatusOptions(order).map((opt) => (
                                        <option
                                          key={opt.value}
                                          value={opt.value}
                                          disabled={opt.disabled}
                                        >
                                          {opt.label}
                                        </option>
                                      ))}
                                    </select>
                                  </li>
                                )}

                              </ul>
                            </div>
                            </div>
                          </td>
                        </tr>
                        {expandedRowId === order.id && isParent && (
  <tr className="bg-light">
    <td colSpan="10">
      <strong>Child Orders</strong>
      <table className="table table-sm mt-2">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Status</th>
            <th>Server</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          
        <tr className="fw-bold">
          <td>{order.orderid}</td>
          <td>{getOrderStatusLabel(order.orderstatus)}</td>
          <td>{getServerName(order)}</td>
          <td>{formatShortDate(order.created_at)}</td>
          <td>
            <button
              className="btn btn-sm btn-primary"
              onClick={() => setOrderId(order.id)}
              data-bs-toggle="modal"
              data-bs-target="#orderDetailModal"
            >
              Details
            </button>

            &nbsp;

            <button
              className="btn btn-sm btn-primary"
              onClick={handlePrint(order.id, false, "kitchen")}
            >
              Kitchen
            </button>

            &nbsp;

            {order.orderstatus < 5 ? (
              <button
                className="btn btn-sm btn-warning"
                onClick={() => handleEditOrder(order)}
              >
                Edit
              </button>
            ) : (
              <button className="btn btn-sm btn-secondary" disabled>
                Edit
              </button>
            )}
          </td>

        </tr>

          {order.childOrders.map((child) => (
            <tr key={child.id}>
              <td>{child.orderid}</td>
              <td>{getOrderStatusLabel(child.orderstatus)}</td>
              {/* <td>{getOrderStatusLabel(order.orderstatus)}</td> */}
              <td>{getServerName(child)}</td>
              <td>{formatShortDate(child.created_at)}</td>
              <td>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => setOrderId(child.id)}
                  data-bs-toggle="modal"
                  data-bs-target="#orderDetailModal"
                >
                  Details
                </button>
                 &nbsp;&nbsp;
                <button
                       className="btn btn-sm btn-primary"
                        onClick={handlePrint(child.id, false, "kitchen")}
                      >
                        Kitchen
                      </button>
                      {order.orderstatus < 5 ? (
  <button
    className="btn btn-sm btn-warning"
    onClick={() => handleEditOrder(child)}
  >
    Edit
  </button>
) : (
  <button className="btn btn-sm btn-secondary" disabled>
    Edit
  </button>
)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </td>
  </tr>
)}

                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <nav className="mb-3" aria-label="Page navigation example">
              <ul className="pagination paginationStyle gap-2 justify-content-center">
                <li className={`page-item ${meta.currentPage === 1 ? "disabled" : ""}`}>
                  <a
                    href="#"
                    className="pageLink"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(meta.currentPage - 1);
                    }}
                  >
                    <svg width="8" height="14" className="paginationArrow">
                      <use xlinkHref="./images/sprite.svg#iconLinkAngleLeft"></use>
                    </svg>
                  </a>
                </li>

                {getPaginationPages().map((page, index) => (
                  <li key={index} className="page-item">
                    {page === "..." ? (
                      <span className="page-link">...</span>
                    ) : (
                      <a
                        href="#"
                        className={`page-link ${
                          meta.currentPage === page ? "primary" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(page);
                        }}
                      >
                        {page}
                      </a>
                    )}
                  </li>
                ))}

                
                <li
                  className={`page-item ${
                    meta.currentPage === meta.pageCount ? "disabled" : ""
                  }`}
                >
                  <a
                    href="#"
                    className="pageLink"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(meta.currentPage + 1);
                    }}
                  >
                    <svg width="8" height="14" className="paginationArrow">
                      <use xlinkHref="./images/sprite.svg#iconLinkAngleRight2"></use>
                    </svg>
                  </a>
                </li>

              </ul>
            </nav>
          </div>
          
          
          {confirmTraining && (
            <div className="modal show d-block">
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content p-3">
                  <p>The selected orders will be deleted permanently.</p>
                  <div className="d-flex gap-2 justify-content-end">
                    <button
                      className="btn btn-danger"
                      onClick={confirmMarkTrainingOrders}
                    >
                      Confirm
                    </button>
                    <button
                      className="btn btn-secondary"
                      onClick={() => setConfirmTraining(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <OrderDetails orderId={orderId} onlySub={true} />
          <DriverUpdateModal
            isOpen={showDriverModal}
            orderId={driverOrderId}
            onClose={() => {
              setShowDriverModal(false);
              setDriverOrderId(null);
            }}
            onSuccess={() => fetchOrders(meta.currentPage)}
          />

          <RefundModal
            isOpen={showRefundModal}
            orderId={refundOrder?.id}
            amount={refundOrder?.amount}
            onClose={() => {
              setShowRefundModal(false);
              setRefundOrder(null);
            }}
            onRefundInitiated={(sessionId) => {
              setRefundSessionId(sessionId);
              setShowRefundStatusModal(true);
            }}
          />

          <LinklyRefundStatusModal
            isOpen={showRefundStatusModal}
            uuid={refundSessionId}
            amount={refundOrder?.amount}
            onClose={() => {
              setShowRefundStatusModal(false);
              setRefundSessionId(null);
            }}
            onRefundComplete={() => fetchOrders(meta.currentPage)}
          />

        </div>
      </div>
    </MainLayoutWithoutFooter>
  );
};

export default Orders;
